export default __webpack_public_path__ + "static/media/txt_h4.29fa0038.svg";